import { render } from "./ProgressDoughnutChart.vue?vue&type=template&id=4ec8eda8&scoped=true"
import script from "./ProgressDoughnutChart.vue?vue&type=script&lang=js"
export * from "./ProgressDoughnutChart.vue?vue&type=script&lang=js"

import "./ProgressDoughnutChart.vue?vue&type=style&index=0&id=4ec8eda8&scoped=true&lang=css"

import exportComponent from "D:\\EME_MARKETING_AND_CONSULTING\\_Proyectos\\bookapps\\Apps Code\\web-admin-bookapps-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ec8eda8"]])

export default __exports__